import { useState } from 'react';
import { fetchWithAuth } from '../../../utils/apiAuth';
import config from '../../../config';

const apiBaseUrl = config.getApiUrl();

export const isValidWhatsappPhone = (phone) => /^91[6-9]\d{9}$/.test(phone);

export const useWhatsApp = (showSnackbar) => {
  const [whatsappForm, setWhatsappForm] = useState({ phone: '', utmCode: 'whtspfriday' });
  const [whatsappSending, setWhatsappSending] = useState(false);

  const handleSendWhatsAppSingle = async () => {
    if (!isValidWhatsappPhone(whatsappForm.phone)) {
      showSnackbar('Please enter a valid phone number in the format 91XXXXXXXXXX', 'error');
      return;
    }

    setWhatsappSending(true);
    try {
      const data = await fetchWithAuth(`${apiBaseUrl}/api/whatsapp/send-single`, {
        method: 'POST',
        body: JSON.stringify({
          phone: whatsappForm.phone,
          utmCode: whatsappForm.utmCode
        })
      });

      showSnackbar(data.message || 'WhatsApp message sent successfully', 'success');
      setWhatsappForm(prev => ({ ...prev, phone: '' }));
    } catch (err) {
      showSnackbar(err.message || 'Failed to send WhatsApp message', 'error');
    } finally {
      setWhatsappSending(false);
    }
  };

  return {
    whatsappForm,
    setWhatsappForm,
    whatsappSending,
    isValidWhatsappPhone,
    handleSendWhatsAppSingle
  };
};
